import React, { useState } from "react";
import "./vendorForm.css";

const VendorForm = () => {
  const [form, setForm] = useState({
    companyName: "",
    email: "",
    contactPerson: "",
    brand: "",
    website: "",
    socialMedia: "",
    category: "Art & Crafts",
    description: "",
    privacyPolicy: false,
  });

  const [status, setStatus] = useState(null); // null | "loading" | "success" | "error"

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");

    try {
      const res = await fetch("/api/subscribe", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      if (!res.ok) throw new Error("Failed");

      setStatus("success");
      window.location.href = "https://www.bizbazevents.com/thank-you";
    } catch {
      setStatus("error");
    }
  };

  return (
    <div className="vendor-wrap">
      <div className="vendor-inner">

        <div className="vendor-header">
          <span className="vendor-eyebrow">Join our vendor Community</span>
          <h1 className="vendor-title">Join BizBaz Events</h1>
          <p className="vendor-subtitle">Fill in your details below and we'll be in touch</p>
        </div>

        <form onSubmit={handleSubmit} className="aweber-form">

          {/* Business Info */}
          <div className="form-section-label"><span>Business info</span></div>

          <div className="form-row">
            <div className="form-group">
              <label>Company Name</label>
              <input
                type="text"
                name="companyName"
                value={form.companyName}
                onChange={handleChange}
                placeholder="Your company name"
                required
              />
            </div>

            <div className="form-group">
              <label>Contact Person</label>
              <input
                type="text"
                name="contactPerson"
                value={form.contactPerson}
                onChange={handleChange}
                placeholder="Full name"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="you@example.com"
                required
              />
            </div>

            <div className="form-group">
              <label>Brand as Advertised</label>
              <input
                type="text"
                name="brand"
                value={form.brand}
                onChange={handleChange}
                placeholder="Your brand name"
              />
            </div>
          </div>

          {/* Online Presence */}
          <div className="form-section-label"><span>Online presence</span></div>

          <div className="form-row">
            <div className="form-group">
              <label>Website</label>
              <input
                type="text"
                name="website"
                value={form.website}
                onChange={handleChange}
                placeholder="www.yourbrand.com"
              />
            </div>

            <div className="form-group">
              <label>Social Media Handles</label>
              <input
                type="text"
                name="socialMedia"
                value={form.socialMedia}
                onChange={handleChange}
                placeholder="@yourbrand"
              />
            </div>
          </div>

          {/* Product Info */}
          <div className="form-section-label"><span>Product info</span></div>

          <div className="form-group">
            <label>Category</label>
            <select
              name="category"
              value={form.category}
              onChange={handleChange}
            >
              <option>Art & Crafts</option>
              <option>Clothing & Jewellery</option>
              <option>Food & Drinks</option>
              <option>Interior Decor</option>
              <option>Outdoors</option>
              <option>Recycled & Repurposed</option>
              <option>Leather & Canvas</option>
              <option>Other</option>
            </select>
          </div>

          <div className="form-group">
            <label>Description</label>
            <textarea
              name="description"
              value={form.description}
              onChange={handleChange}
              rows="4"
              placeholder="Tell us about your products or services..."
              required
            />
          </div>

          {/* Privacy */}
          <div className="form-group checkbox-group">
            <label className="checkbox-label">
              <input
                type="checkbox"
                name="privacyPolicy"
                checked={form.privacyPolicy}
                onChange={handleChange}
                required
              />
              <span>
                I have read the{" "}
                <a
                  href="https://www.bizbazevents.com/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  privacy policy
                </a>
              </span>
            </label>
          </div>

          <button type="submit" className="submit-btn" disabled={status === "loading"}>
            {status === "loading" ? "Submitting..." : "Submit"}
          </button>

          {status === "error" && (
            <p className="form-error">
              Something went wrong. Please try again or contact us directly.
            </p>
          )}

        </form>
      </div>
    </div>
  );
};

export default VendorForm;